export default __webpack_public_path__ + "static/img-art-pandas-profiling-10-5a3b806184f4043043c3a41b2d5fed10.png";